import { render, staticRenderFns } from "./ToolbarPagination.html?vue&type=template&id=3ffefc34&"
import script from "./ToolbarPagination.ts?vue&type=script&lang=ts&"
export * from "./ToolbarPagination.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/properties/_toolbar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports